module.exports = __webpack_public_path__ + "img/logo-text.42b0000a.svg";